const PERF_QUERY_PARAM = 'perf';
const PERF_QUERY_VALUE = '1';
const STORE_KEY = '__PINGCO_BOOT_TRACE__';

function canUseWindow() {
    return typeof window !== 'undefined' && typeof performance !== 'undefined';
}

export function isBootTraceEnabled() {
    if (!import.meta.env.DEV || !canUseWindow()) {
        return false;
    }

    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(PERF_QUERY_PARAM) === PERF_QUERY_VALUE;
}

function getBootTraceStore() {
    if (!canUseWindow()) {
        return null;
    }

    if (!window[STORE_KEY]) {
        const now = performance.now();
        window[STORE_KEY] = {
            sequence: 0,
            startedAt: now,
            lastAt: now,
        };
    }

    return window[STORE_KEY];
}

export function traceBoot(label, meta = {}) {
    if (!isBootTraceEnabled()) {
        return null;
    }

    const store = getBootTraceStore();
    if (!store) {
        return null;
    }

    const now = performance.now();
    const entry = {
        seq: ++store.sequence,
        label,
        t: Number((now - store.startedAt).toFixed(1)),
        dt: Number((now - store.lastAt).toFixed(1)),
        ...meta,
    };

    store.lastAt = now;
    console.info(`[BOOT:trace] ${JSON.stringify(entry)}`);

    return entry;
}
